import { render, staticRenderFns } from "./account.page.vue?vue&type=template&id=24f7f8d4&"
import script from "./account.page.vue?vue&type=script&lang=ts&"
export * from "./account.page.vue?vue&type=script&lang=ts&"
import style0 from "./account.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports